const MANAGE_CLAIM_METHODS_STEPS = {
  REMOVE_CLAIM_METHOD: 'removeClaimMethod',
  VERIFY_CLAIM_CONTACT_TO_DELETE: 'verifyClaimMethodToDelete',
};

export { MANAGE_CLAIM_METHODS_STEPS };
